import OnvoBase from "../base.js";
import { WidgetSuggestion } from "../types/index.js";

export class OnvoWidgetSuggestions extends OnvoBase {
    #dashboardId: string;

    constructor(
        dashboardId: string,
        apiKey: string,
        options?: { endpoint: string }
    ) {
        super(apiKey, options);
        this.#dashboardId = dashboardId;
    }

    /**
     * Links a datasource to a dashboard.
     *
     * @return {Promise<WidgetSuggestion[]>} A promise that resolves to the linked dashboard datasource.
     */
    list(): Promise<WidgetSuggestion[]> {
        return this._fetchBase(
            "/api/dashboards/" + this.#dashboardId + "/widget-suggestions",
            "GET"
        ) as Promise<WidgetSuggestion[]>;
    }

    /**
     * Links a datasource to a dashboard.
     *
     * @param {string} id - The ID of the widget suggestion to delete.
     * @return {Promise<{ success: boolean }>} A promise that resolves to the linked dashboard datasource.
     */
    delete(id: string): Promise<{ success: boolean }> {
        return this._fetchBase(
            "/api/dashboards/" + this.#dashboardId + "/widget-suggestions/" + id,
            "DELETE"
        ) as Promise<{ success: boolean }>;
    }
}
